import menu from "./menu";
import accountManagement from "./account-management";

const mainMenu = {
  items: [...menu, accountManagement]
};

export default mainMenu;
